import $ from "jquery";

function RadioToggle() {
  //radioがチェック状態なら初期表示
  $(".js-radio-toggle-trigger").each(function () {
    $(this).prop("checked") == true && $(this).closest(".js-radio-toggle").addClass("is-open");
    $(this).prop("checked") == true && $(this).closest(".js-radio-toggle").next(".js-radio-toggle-panel").show();
  });

  //ボタン押下でアコーディオン開閉
  $(".js-radio-toggle-trigger").on("change", function () {
    if ($(this).is(":checked")) {
      const targetToggle = $(this).closest(".js-radio-toggle");
      const targetPanel = targetToggle.next(".js-radio-toggle-panel");

      // ターゲット以外のトグルを閉じる
      $(".js-radio-toggle").not(targetToggle).removeClass("is-open");
      $(".js-radio-toggle-panel").not(targetPanel).slideUp();
      // aria属性
      $(".js-radio-toggle-trigger").not($(this));
      $(".js-radio-toggle-panel").not(targetPanel);

      // 選択されたラジオボタンのトグルを開く
      targetToggle.addClass("is-open");
      targetPanel.slideDown();
    }
  });
}

export { RadioToggle };
